// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

var container = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.selector("*", [BsCssJs$PrezzeeRibbon.boxSizing("borderBox")])
    ]);

var Style = {
  container: container
};

function LargeHeroTile(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: container
            });
}

var Background;

var Foreground;

var Heading;

var BodyText;

var CtaLine;

var make = LargeHeroTile;

export {
  Background ,
  Foreground ,
  Heading ,
  BodyText ,
  CtaLine ,
  Style ,
  make ,
}
/* container Not a pure module */
